export default {
    h1: 'Preguntas frecuentes',
    title: 'Caracterìstic as de Airclass',
    title1: 'Preguntas Técnicas',
    q: 'P',
    feature: [
        {
            question: 'qué funciones son disponibles?',
            answer: `Tenemos softwares didácticos, pizarra coraborativa, y múltiples
            formas de  interacciones entre el profrsor y el estudiante. Asistencia en línea es disponible en cualquier momento si encuentras problemas.`,
        },
        {
            question: 'Voy a necesitar un micrófono y cámara?',
            answer: 'Sí, necesita un micrófono y una cámara para que pueda comunicarse directamente con el tutor.',
        },
        {
            question: 'Cómo funciona la reproducción?',
            answer: `En cuanto comience la clase, el sistema grabará el sonido automáticamente
            y todo el contenido de la clase, y usted puede ver la reproducción de parte de cliente cuando acabe la class. No se preocupe por su privacidad, que su foto en el vídeo no será visible.`,
        },
        {
            question: 'Cómo puedo contar con la ayuda en línea？',
            answer: `Si encuentra cualquier problema durante la clase, puede hacer un clic
            en el botón "Online help" de arriba a la izquierda. Después de hacer su pregunta, nuestro asistente de apoyo técnico va a establecer un diálogo con usted inmediatamente para solucionar su problema.`,
        }
    ],
    enterClassRoom: ` <p>Before using AirClass, please close Zoom, Google Meet and other meeting programs. Then perform device detection.</p>
    <p>The camera can only be seen when both parties enter the classroom.</p>
    <p>Please re-plug the external device and check if it is connected. Refresh the classroom afterwards.</p>
    <p>If you still can't see it during the class, please check if you are using the correct client.</p>`,
    technicalSupport: [
        {
            question: 'Está fallada la instalación de una nueva versión',
            answer: 'Por favor desinstale primero la versión anterior'
        },
        {
            question: 'Mi pantalla se vuelve blanca cuando inicio sesión en Airclass de versión cliente.',
            answer: 'Por favor trata de reestablecer la versión cliente e iniciar sesión de nuevo.'
        },
        {
            question: 'No puede ver el horario a través de la app versión cliente',
            answer: `Las últimas clases van a aparecer en la página de inicio. Por faovr vaya al calendario de clase
            a revisar todas las clases agendadas.`
        },
        {
            question: 'No se puede ver el vídeo o escuchar el sonido después de entrar en el aula.',
            answer: `Antes de usar Airclass, por favor elija Zoom, Google Meet y otros programas, y luego active el dispositivo de detección. la cámara sólo puede funcionar cuando ambas personas entran en el aula. Por favor vuelva a poner el dispositivo externo y confirmar si está bien conectado y actualice el aula después. Si no funciona todavía al final, por favor chequee si está usando la correcta
            versión cliente
            `
        },
    ]


}